import React from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import MultiSelect from '../shared/inputs/MultiSelect';

const DateDesignerLeadFilter = ({
    filter,
    setFilter,
    hideDesignerFilter,
    hideLeadFilter
}) => {
    const updateLeads = ({ target: { value, name } }) => {
        //reset SubLeadSource when LeadSource values are set
        setFilter([{ name: 'subLeadSourceIds', value: [] }, { name: name, value: value }]);
    }

    return (
        <Form.Row>
            <Col sm>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            From
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            defaultValue={filter.dateFrom}
                            name="dateFrom"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            To
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            defaultValue={filter.dateTo}
                            name="dateTo"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    {!hideDesignerFilter &&
                        <Form.Group as={Col} sm>
                            <Form.Label className="col-form-label-sm">
                                Designers
                            </Form.Label>
                            <MultiSelect
                                filter={{
                                    franchiseId: filter.franchiseId
                                }}
                                lookupType="Designer"
                                name="designerIds"
                                onChange={setFilter}
                                value={filter.designerIds}
                            />
                        </Form.Group>
                    }
                    {!hideLeadFilter &&
                        <Form.Group as={Col} sm>
                            <Form.Label className="col-form-label-sm">
                                Lead Source
                            </Form.Label>
                            <MultiSelect
                                filter={{
                                    franchiseId: filter.franchiseId
                                }}
                                lookupType="LeadSource"
                                name="leadSourceIds"
                                onChange={updateLeads}
                                value={filter.leadSourceIds}
                            />
                        </Form.Group>
                    }{!hideLeadFilter &&
                    <Form.Group as={Col} sm>
                        <Form.Label className="col-form-label-sm">
                            Sub Lead Source
                                </Form.Label>
                        <MultiSelect
                            filter={{
                                leadSourceIds: filter.leadSourceIds,
                                franchiseId: filter.franchiseId
                            }}
                            lookupType={filter.leadSourceIds && 'SubLeadSource'}
                            name="subLeadSourceIds"
                            onChange={setFilter}
                            value={filter.subLeadSourceIds}
                        />
                    </Form.Group>
                    }
                </Form.Row>
            </Col>
        </Form.Row>
    );
}

export default React.memo(DateDesignerLeadFilter);